import React from "react";
import { CloseIcon, WarningIcon } from "../utils/confirm/confirm";

interface AlertProps {
  showAlert: boolean;
  handleStayEditing: () => void;
  handleDiscardChanges: () => void;
}

const Alert: React.FC<AlertProps> = ({ showAlert, handleStayEditing, handleDiscardChanges }) => {
  if (!showAlert) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={handleStayEditing} 
    >
      <div
        className="flex flex-col items-center justify-between w-5/12 p-4 rounded-lg  h-48 "
        style={{
          minWidth: "300px",
          background: "#f5f5f5"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="flex items-center font-title justify-between w-full pb-2 ">
          <div className="flex flex-row items-center justify-center gap-x-4">
            <WarningIcon />
            <label className="text-lg font-bold "> You have unsaved changes in challenges!</label>
          </div>
          <CloseIcon className="cursor-pointer text-black hover:scale-110 hover:text-red-600" onClick={handleStayEditing} />
        </header>
        <div className="flex items-center justify-center m-auto rounded-lg">
          <label className="text-lg text-black text-center">Are you sure you want to discard?</label>
        </div>
        <div className="flex items-center justify-center gap-x-4">
          <button className=" bg-red-500 text-white px-4 py-2 rounded" onClick={handleDiscardChanges}>
            Discard
          </button>
          <button className=" bg-gray-300  px-4 py-2 rounded mr-2 " onClick={handleStayEditing}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Alert;
